const TEXT_TYPES = {
  SIMPLE_TEXT: 'Simple text',
  EMAIL: 'Email',
  PHONE: 'Phone',
  TEXTAREA: 'Textarea'
}
export default TEXT_TYPES
